/*
  Copy button for the signup card: copies the discount code next to it.
*/
(function () {
  document.addEventListener('click', function (event) {
    var copy = event.target.closest('[data-fm-signup] [data-fm-copy]');
    if (!copy) return;
    var card = copy.closest('[data-fm-signup]');
    var codeEl = card && card.querySelector('[data-fm-code]');
    var code = codeEl ? codeEl.textContent.trim() : '';
    if (!code || !navigator.clipboard || !navigator.clipboard.writeText) return;
    navigator.clipboard.writeText(code).then(function () {
      var label = copy.textContent;
      copy.textContent = copy.getAttribute('data-copied-label') || label;
      window.setTimeout(function () {
        copy.textContent = label;
      }, 2000);
    }, function () {});
  });
})();
